import api from '..'

export const getHotPicks = (params) => {
  return api.get('/hot-picks', params, 'bearer')
}

export const sendHotPickLike = (hotPickId, body) => {
  return api.post(`/hot-picks/${hotPickId}/like`, body, 'bearer')
}
